import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode';
import { generateSampleCode } from '../utils/generateSampleCode';
import QRScanModal from './QRScanModal';
import { printQrLabel, downloadQrLabel } from '../utils/qrLabel';

export default function QRCodeField({ value, onChange, initials, autoGenerateIfEmpty }) {
  const { t } = useTranslation('common');
  const [qrDataUrl, setQrDataUrl] = useState('');
  const [scanning, setScanning] = useState(false);
  const didAutoGenerate = useRef(false);

  useEffect(() => {
    if (autoGenerateIfEmpty && !value && !didAutoGenerate.current) {
      didAutoGenerate.current = true;
      onChange(generateSampleCode(initials));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!value) { setQrDataUrl(''); return; }
    let cancelled = false;
    QRCode.toDataURL(value, { width: 220, margin: 1 })
      .then(url => { if (!cancelled) setQrDataUrl(url); })
      .catch(() => { if (!cancelled) setQrDataUrl(''); });
    return () => { cancelled = true; };
  }, [value]);

  const regenerate = () => onChange(generateSampleCode(initials));

  const handleDetected = (code) => {
    onChange(code);
    setScanning(false);
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        {qrDataUrl && (
          <img src={qrDataUrl} alt="QR" style={{ width: 72, height: 72, border: '1px solid var(--c-border)', borderRadius: 6 }} />
        )}
        <div>
          <div style={{ fontFamily: 'monospace', fontSize: 14 }} dir="ltr">{value || t('qrField.none')}</div>
          <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
            <button type="button" onClick={regenerate} title={t('tip.qrRegenerate')} style={btnStyle('var(--c-text-muted)')}>{t('qrField.regenerate')}</button>
            <button type="button" onClick={() => setScanning(true)} title={t('tip.qrScan')} style={btnStyle('var(--c-info)')}>{t('qrField.scan')}</button>
            {qrDataUrl && <button type="button" onClick={() => printQrLabel(qrDataUrl, value)} title={t('qrField.printTip')} style={btnStyle('var(--c-success)')}>{t('qrField.print')}</button>}
            {qrDataUrl && <button type="button" onClick={() => downloadQrLabel(qrDataUrl, value)} title={t('qrField.downloadTip')} style={btnStyle('var(--c-success)')}>{t('qrField.download')}</button>}
          </div>
        </div>
      </div>

      <QRScanModal open={scanning} onDetected={handleDetected} onClose={() => setScanning(false)} />
    </div>
  );
}

const btnStyle = (bg) => ({
  background: bg, color: 'var(--c-on-accent)', border: 'none', borderRadius: 6,
  padding: '6px 12px', cursor: 'pointer', fontSize: 13,
});
